import Base from "./base.js";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  COLLEGE_INDEX,
  SHOW_WITH_PROFILE_ID,
  COLLEGE_VIDEOS_INDEX,
  COLLEGE_UPDATE_URL,
  UPLOAD_IMAGE_LOGO,
  DELETE_VIDEO_URL,
  SAVE_COLLEGE_VIDEO_URL,
  UPDATE_COLLEGE_VIDEO_URL,
  UPLOAD_COLLEGE_IMAGES,
  DELETE_COLLEGE_COACH_IMAGES,
  GET_ALL_COLLEGES,
  UPDATE_VIEW_COUNT_COLLEGE
} from "@/utils/api-url";

class College extends Base {
  constructor(params = {}) {
    super(params);
    this.id = params["_id"] || this.Id || this.id || "-";
    this.key = params["_id"] || this.Id || this.key || "-";
    this.collegeName = params["collegeName"] || this.collegeName || "";
    this.city = (params["city"] && params["city"]["name"]) || this.city || "";
    this.division =
      (params["division"] && params["division"]["name"]) ||
      this.division ||
      "-";
    this.divisionId =
      (params["division"] && params["division"]["_id"]) ||
      this.divisionId ||
      "-";
    this.gpaRequired =
      (params["gpaRequired"] && params["gpaRequired"]["name"]) ||
      this.gpaRequired;
    this.gpaRequiredId =
      (params["gpaRequired"] && params["gpaRequired"]["_id"]) ||
      this.gpaRequiredId;
    this.favourite = params["favourite"] || this.favourite || false;
    this.schoolEnrollment =
      (params["school_enrollment"] && params["school_enrollment"]["name"]) ||
      this.schoolEnrollment ||
      "-";
    this.schoolTuition =
      (params["school_tuition"] && params["school_tuition"]["name"]) ||
      this.schoolTuition ||
      "-";
    this.schoolType =
      (params["schoolType"] && params["schoolType"]["name"]) ||
      this.schoolType ||
      "-";
    this.schoolTypeId =
      (params["schoolType"] && params["schoolType"]["_id"]) ||
      this.schoolTypeId ||
      "";
    this.state =
      (params["state"] && params["state"]["name"]) || this.state || "";
    this.stateId =
      (params["state"] && params["state"]["_id"]) || this.stateId || "";
    this.schoolEducationType =
      (params["schoolEducationType"] &&
        params["schoolEducationType"]["name"]) ||
      this.schoolEducationType;
    this.schoolEducationTypeId =
      (params["schoolEducationType"] && params["schoolEducationType"]["_id"]) ||
      this.schoolEducationTypeId;
    this.collegeSetting =
      (params["collegeSetting"] && params["collegeSetting"]["name"]) ||
      this.collegeSetting ||
      "";
    this.collegeSettingId =
      (params["collegeSetting"] && params["collegeSetting"]["_id"]) ||
      this.collegeSettingId ||
      "";
    this.academicSpecialities = params["academicSpecialities"] || [];
    (this.academicSpecitialitiesIds =
      this.academicSpecitialitiesIds ||
      (this.academicSpecialities &&
        this.academicSpecialities.map(item => item._id)) ||
      []),
      (this.videos = params["Videos"] || []);
  }

  static resourceName() {
    return "college";
  }

  static index(params) {
    const profileId = params.profileId || this.profileId();
    return apiDispatcher(COLLEGE_INDEX(params, profileId));
  }

  static show(params) {
    let profileId = "";
    if (JSON.parse(localStorage["user-permissions"]) === "player")
      profileId = params.profileId || this.profileId();
    return apiDispatcher(SHOW_WITH_PROFILE_ID(params, "college", profileId));
  }

  static getVideos(params) {
    return apiDispatcher(COLLEGE_VIDEOS_INDEX(params));
  }

  static getLimitedVideos(params) {
    return apiDispatcher(
      COLLEGE_VIDEOS_INDEX({ ...params, limit: 3, page: 1 })
    );
  }

  static update(params) {
    return apiDispatcher(COLLEGE_UPDATE_URL(params));
  }

  static deleteCollegeVideos(params) {
    return apiDispatcher(DELETE_VIDEO_URL(params));
  }

  static saveCollegeVideos(params) {
    return apiDispatcher(SAVE_COLLEGE_VIDEO_URL(params));
  }

  static updateCollegeVideos(params) {
    return apiDispatcher(UPDATE_COLLEGE_VIDEO_URL(params));
  }

  static uploadCollegeImages(params) {
    return apiDispatcher(UPLOAD_COLLEGE_IMAGES(params));
  }

  static deleteCollegeImages(params) {
    return apiDispatcher(DELETE_COLLEGE_COACH_IMAGES(params));
  }

  static updateViewCount(params) {
    const profileId = this.profileId()

    return apiDispatcher(UPDATE_VIEW_COUNT_COLLEGE(params, profileId));
  }

  static validationRules = {
    collegeName: [{ required: true, message: "College name is required" }],
    city: [{ required: true, message: "City is required" }],
    state: [{ required: true, message: "State is required" }],
    address1: [{ required: true, message: "Address is required" }],
    zip: [{ required: true, message: "ZIP CODE is required" }],
    collegePhone: [{ required: true, message: "Number is required" }]
  };

  static academicValidation = {
    division: [{ required: true, message: "Division is required" }]
  };

  static updateCollegeLogo(params) {
    const id = params.id;
    return apiDispatcher(UPLOAD_IMAGE_LOGO("college", id, params.image));
  }

  static getAllColleges(params) {
    return apiDispatcher(GET_ALL_COLLEGES(params));
  }

  static filterConfig() {
    return [
      {
        component: "BaseTaxonomySelect",
        resource: "collegeGpa",
        type: "College GPA",
        placeholder: "GPA",
        allowClear: true,
        column: "gpaRequired",
        searchType: "normal",
        gridComponent: "one"
      },
      {
        component: "BaseInput",
        placeholder: "College Name",
        searchType: "query",
        column: "q",
        additionalData: { searchField: "collegeName", sort:"collegeName" },
        gridComponent: "two"
      },

      /**
       *  hidden for certian  time
       */

      // {
      //   component: "BaseSortedTaxonomySelect",
      //   resource: "academicSpeciality",
      //   type: "Academic Specialities",
      //   placeholder: "Academic Specialities",
      //   allowClear: true,
      //   hide: this.userRole() === "player" ? false : true,
      //   mode: "multiple",
      //   column: "academicSpecialities",
      //   searchType: "arrayString",
      //   gridComponent: "three",
      //   optionFilterProp: "children",
      //   showSearch: true,
      //   filterOption: true
      // },
      // {
      //   component: "BasePar",
      //   gridComponent: "four",
      //   hide: this.userRole() === "player" ? false : true,

      // },
      {
        component: "BaseTaxonomySelect",
        resource: "division",
        type: "Division",
        placeholder: "Division",
        allowClear: true,
        column: "division",
        searchType: "normal",
        gridComponent: "four"
      },
      {
        component: "BaseSortedTaxonomySelect",
        resource: "collegeState",
        type: "College State",
        placeholder: "State",
        allowClear: true,
        column: "state",
        searchType: "normal",
        gridComponent: "five",
        optionFilterProp: "children",
        showSearch: true,
        filterOption: true
      },
      {
        component: "BaseTaxonomySelect",
        resource: "educationType",
        type: "Education Type",
        placeholder: "Education Type",
        allowClear: true,
        column: "schoolEducationType",
        searchType: "normal",
        gridComponent: "six"
      },
      {
        component: "BaseTaxonomySelect",
        resource: "schoolType",
        type: "School Type",
        placeholder: "School Type",
        allowClear: true,
        column: "schoolType",
        searchType: "normal",
        gridComponent: "seven"
      },
      {
        component: "BaseTaxonomySelect",
        resource: "collegeSetting",
        type: "College Setting",
        placeholder: "College Setting",
        allowClear: true,
        column: "collegeSetting",
        searchType: "normal",
        gridComponent: "eight"
      },
      {
        component: "BaseInputSlider",
        placeholder: "Minimun Tuition",
        step: 500,
        minValue: 0,
        maxValue: 70000,
        column: ["schoolTuition[gte]", "schoolTuition[lte]"],
        label: "School Tuition",
        searchType: "range",
        range: true,
        gridComponent: "nine",
        markerTag: "$"
      },
      {
        component: "BaseInputSlider",
        placeholder: "Minimun Enrollment",
        step: 500,
        minValue: 0,
        maxValue: 20000,
        column: ["schoolEnrollment[gte]", "schoolEnrollment[lte]"],
        label: "School Enrollment",
        searchType: "range",
        range: true,
        gridComponent: "ten",
        markerTag: ""
      },
      {
        component: "BaseButton",
        class: "btn btn-default primary-button-extra-class",
        type: "primary",
        searchType: "Submit",
        gridComponent: "eleven",
        label: "Search",
        clickable: true
      }
    ];
  }

  static coachPermissions = {
    collegeNormalCoach: 1,
    collegeProfileMaintainer: 2,
    collegeHeadCoach: 3
  };
}

export default College;
